export default "/images/48fafe8ebf767d0a4df34db1f156dc7d.png";